// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* In your CSS or styled-components */
.rotate-180 {
    transition: transform 0.6s ease;
    transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/pages/RecordInsertion/OfferingEditing/OfferingEditingSections/XFeed.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B","sourcesContent":["/* In your CSS or styled-components */\n.rotate-180 {\n    transition: transform 0.6s ease;\n    transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
